module.exports = __webpack_public_path__ + "img/handan-ae9302.png";